var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [
                  _c("b", [_vm._v(_vm._s(_vm.$t("Feedback.DecisionDate")))])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          [
            _vm._v(
              _vm._s(
                _vm._f("formatDatetime")(_vm.model.decisionDate, "D.M.YYYY")
              )
            )
          ]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [_c("b", [_vm._v(_vm._s(_vm.$t("OrganisationName")))])]
              },
              proxy: true
            }
          ])
        },
        [_vm._v(" "), [_vm._v(_vm._s(_vm.organisationName))]],
        2
      ),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [
                  _c("b", [_vm._v(_vm._s(_vm.$t("Pdf.OrganisationNumber")))])
                ]
              },
              proxy: true
            }
          ])
        },
        [_vm._v(" "), [_vm._v(_vm._s(_vm.organisationNumber))]],
        2
      ),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [_c("b", [_vm._v(_vm._s(_vm.$t("AidTargetNumber")))])]
              },
              proxy: true
            }
          ])
        },
        [_vm._v(" "), [_vm._v(_vm._s(_vm.model.aidTargetNumber))]],
        2
      ),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [_c("b", [_vm._v(_vm._s(_vm.$t("Purpose")))])]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          [
            _c("span", {
              staticClass: "preformatted",
              domProps: { innerHTML: _vm._s(_vm.model.purpose) }
            })
          ]
        ],
        2
      ),
      _vm._v(" "),
      _vm.isApproved
        ? _c(
            "div",
            [
              _c(
                "text-label-control",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "label",
                        fn: function() {
                          return [
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.$t("TargetChange.NewAidTarget"))
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2624130794
                  )
                },
                [_vm._v(" "), [_vm._v(_vm._s(_vm.model.newAidTarget))]],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [
                  _c("b", [_vm._v(_vm._s(_vm.$t("ChangeRequests.Decision")))])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          [
            _c("span", {
              staticClass: "preformatted",
              domProps: { innerHTML: _vm._s(_vm.model.feedbackDecision) }
            })
          ]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("ChangeRequests.DecisionArguments")))
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          [
            _c("span", {
              staticClass: "preformatted",
              domProps: {
                innerHTML: _vm._s(_vm.model.feedbackDecisionArguments)
              }
            })
          ]
        ],
        2
      ),
      _vm._v(" "),
      _vm.model.introducerNoteOfDissent
        ? _c(
            "text-label-control",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("b", [
                          _vm._v(_vm._s(_vm.$t("ChangeRequests.NoteOfDissent")))
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2846662323
              )
            },
            [
              _vm._v(" "),
              [
                _c("span", {
                  staticClass: "preformatted",
                  domProps: {
                    innerHTML: _vm._s(_vm.model.introducerNoteOfDissent)
                  }
                })
              ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.model.showDecisionMaker
        ? _c(
            "text-label-control",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.$t("Feedback.Decision.DecisionMaker"))
                          )
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                610654091
              )
            },
            [
              _vm._v(" "),
              [_vm._v(_vm._s(_vm.model.record.decisionMaker.contactInfo))]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("div", {
        domProps: { innerHTML: _vm._s(_vm.$t("decisionAppealsInstructions")) }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }